import { Link } from 'react-router-dom';
import type { ContentItem } from '@/mocks/catalog';
import { ratingLabel } from '@/utils/format';

interface MovieCardProps {
  item: ContentItem;
  badge?: string;
}

export default function MovieCard({ item, badge }: MovieCardProps) {
  const typeLabel = item.type === 'movie' ? '电影' : '剧集';

  return (
    <Link
      to={`/detail/${item.id}`}
      className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200 hover:border-primary-300 transition-colors"
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-200">
        <img
          src={item.poster}
          alt={`${item.title}海报`}
          title={`${item.title} - ${item.genres.join(' ')}`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute top-2 left-2 px-2 py-0.5 rounded-md bg-background-950/70 text-background-50 text-xs">
          {badge || typeLabel}
        </span>
        <span className="absolute bottom-2 right-2 flex items-center gap-1 px-2 py-0.5 rounded-md bg-accent-500 text-foreground-950 text-xs font-label font-bold">
          <i className="ri-star-fill text-[10px]"></i>
          {ratingLabel(item.rating)}
        </span>
      </div>
      <div className="p-3">
        <h3 className="text-sm font-semibold text-foreground-950 truncate group-hover:text-primary-600 transition-colors">
          {item.title}
        </h3>
        <p className="mt-1 text-xs text-foreground-500 truncate">
          {item.year} · {item.genres.slice(0, 2).join(' / ')}
        </p>
      </div>
    </Link>
  );
}